module.exports = __webpack_public_path__ + "media/newstyle/images/stars_4-7ab315edfff54964d1caedfaa9f1df35.svg";